import React, { useEffect, useMemo, useRef } from "react";
import Check from "./Check";
import wizard_css from "../../inspection.module.css";

export default function CheckCheckBox({
  check,
  equipment,
  topLevel,
  tosubequipmentinspection,
  station,
  data,
  set_data,
  saveTextCommentAndPhoto,
  deleteComment,
  index,
  setCheckValue,
  type,
  addInterceptor,
  params,
}) {
  const checkRef = useRef();
  const timeAndUserLabel = useMemo(
    () =>
      check.time && "" + check.closedItemComment === ""
        ? "Opened: " + check.time + " " + check.user
        : "",
    [check.closedItemComment, check.time, check.user]
  );

  const statusLabel = useMemo(
    () => (check.status ? "Status: " + check.status : ""),
    [check.status]
  );
  const closeTimeAndUserLabel = useMemo(
    () =>
      "" + check.closedItemComment !== ""
        ? "Closed: " + check.closeTime + " " + check.closeUser
        : "",
    [check.closeTime, check.closeUser, check.closedItemComment]
  );
  const correctiveActionLabel = useMemo(
    () =>
      "" + check.closedItemComment !== ""
        ? "Corrective action: " + check.closedItemComment
        : "",
    [check.closedItemComment]
  );
  const correctiveActionPhotoHref = useMemo(
    () => ("" + check.closedItemPhoto !== "" ? check.closedItemPhoto : ""),
    [check.closedItemPhoto]
  );
  const correctiveActionLinkLabel = useMemo(
    () => ("" + check.closedItemPhoto !== "" ? "view image" : ""),
    [check.closedItemPhoto]
  );

  useEffect(() => {
    if (topLevel && !check.value) {
      setCheckValue(true, check.id, topLevel);
    }
  }, [check.id, check.value, index, setCheckValue, topLevel]);

  useEffect(() => {
    window.$(checkRef.current).popover();
  }, []);

  return (
    <>
      {!topLevel && (
        <label
          className={`btn btn-default ${check.locked ? "btn-danger" : ""}`}
        >
          <span
            className={`${
              +check.open === 0 && check.opensItem ? "closed-item" : ""
            }`}
          >
            {check.title}
          </span>{" "}
          {!check.locked && (
            <input
              type="checkbox"
              checked={!!check.value}
              onChange={(e) =>
                setCheckValue(e.target.checked, check.id, topLevel)
              }
            />
          )}
        </label>
      )}

      <div style={{ display: "inline-block" }}>
        {(+check.open === 1 ||
          !!check.status ||
          "" + check.closedItemComment !== "") && (
          <div>
            <span
              ref={(ref) => (checkRef.current = ref)}
              className="btn btn-link p-0 popover-checks"
              role="button"
              data-toggle="popover"
              data-placement="right"
              data-content={`<div>
                    <div>${timeAndUserLabel}</div>
                    <div>${statusLabel}</div>
                    <div>${closeTimeAndUserLabel}</div>
                    <div>${correctiveActionLabel} <a href='${correctiveActionPhotoHref}' data-lightbox='${check.title}'>${correctiveActionLinkLabel}</a></div>
                    </div>`}
              data-html="true"
              tabIndex="0"
              data-trigger="focus"
              data-original-title=""
              title=""
            >
              <i
                className="fa fa-info-circle fa-2x "
                aria-hidden="true"
                title="Write-up Details"
                aria-label="Write-up Details"
              ></i>
            </span>
          </div>
        )}
      </div>
      {(!!check.value || !!topLevel) && (
        <div className={`${wizard_css["sub-checks"]} clearfix`}>
          {check.children.map((child, child_index) => (
            <Check
              key={child_index}
              check={child}
              equipment={equipment}
              topLevel={false}
              station={station}
              tosubequipmentinspection={tosubequipmentinspection}
              data={data}
              set_data={set_data}
              saveTextCommentAndPhoto={saveTextCommentAndPhoto}
              deleteComment={deleteComment}
              index={index}
              type={type}
              setCheck={setCheckValue}
              addInterceptorValue={addInterceptor}
              params={params}
              className="check" // TODO CHECK
            ></Check>
          ))}
        </div>
      )}
    </>
  );
}
